export const PatientHistoryForm = {
  flow: 'y',
  gap: 'Z',
  padding: 'B',
  background: 'inkSurface',
  round: 'Z',
  border: '1px solid inkBorder',
  width: '100%',

  FormTitle: {
    flow: 'x',
    align: 'center space-between',

    TitleText: {
      text: '{{ addDentalHistory | polyglot }}',
      fontSize: 'A',
      fontWeight: '700',
      color: 'inkText'
    },

    PatientReportedBadge: {
      text: '{{ patientReported | polyglot }}',
      fontSize: 'Y',
      fontWeight: '600',
      padding: 'X Y',
      round: 'B',
      background: 'orange.15',
      color: 'orange'
    }
  },

  ToothSelector: {
    flow: 'y',
    gap: 'X',

    ToothLabel: {
      text: '{{ toothNumber | polyglot }}',
      fontSize: 'Y',
      color: 'inkMuted',
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: 'X'
    },

    ToothSelect: {
      tag: 'select',
      padding: 'Y Z',
      round: 'Y',
      border: '1px solid inkBorder',
      background: 'inkMid',
      color: 'inkText',
      fontSize: 'Z',
      width: '100%',
      cursor: 'pointer',
      value: (el, s) => s.historyFormTooth || '',
      onChange: (el, s) => {
        s.update({ historyFormTooth: el.node.value })
      },
      OptionDefault: { tag: 'option', value: '', text: '{{ selectTooth | polyglot }}' },
      $collection: (el, s) => {
        var teeth = []
        var quads = [[11,12,13,14,15,16,17,18],[21,22,23,24,25,26,27,28],[31,32,33,34,35,36,37,38],[41,42,43,44,45,46,47,48]]
        for (var q = 0; q < quads.length; q++) {
          for (var t = 0; t < quads[q].length; t++) {
            teeth.push({ tag: 'option', value: String(quads[q][t]), text: 'Tooth #' + quads[q][t] })
          }
        }
        return teeth
      }
    }
  },

  ProcedureSelector: {
    flow: 'y',
    gap: 'X',

    ProcLabel: {
      text: '{{ procedureType | polyglot }}',
      fontSize: 'Y',
      color: 'inkMuted',
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: 'X'
    },

    ProcSelect: {
      tag: 'select',
      padding: 'Y Z',
      round: 'Y',
      border: '1px solid inkBorder',
      background: 'inkMid',
      color: 'inkText',
      fontSize: 'Z',
      width: '100%',
      cursor: 'pointer',
      value: (el, s) => s.historyFormProcedure || '',
      onChange: (el, s) => {
        s.update({ historyFormProcedure: el.node.value })
      },
      OptionDefault: { tag: 'option', value: '', text: '{{ selectProcedure | polyglot }}' },
      OptionFilling: { tag: 'option', value: 'Filling', text: '{{ filling | polyglot }}' },
      OptionCrown: { tag: 'option', value: 'Crown', text: '{{ crown | polyglot }}' },
      OptionRootCanal: { tag: 'option', value: 'Root Canal', text: '{{ rootCanal | polyglot }}' },
      OptionExtraction: { tag: 'option', value: 'Extraction', text: '{{ extraction | polyglot }}' },
      OptionImplant: { tag: 'option', value: 'Implant', text: '{{ implantProc | polyglot }}' },
      OptionCleaning: { tag: 'option', value: 'Cleaning', text: '{{ cleaningProc | polyglot }}' },
      OptionWhitening: { tag: 'option', value: 'Whitening', text: '{{ whiteningProc | polyglot }}' },
      OptionBraces: { tag: 'option', value: 'Braces', text: '{{ bracesProc | polyglot }}' },
      OptionOther: { tag: 'option', value: 'Other', text: '{{ other | polyglot }}' }
    }
  },

  DateRow: {
    flow: 'x',
    gap: 'Z',

    MonthField: {
      flow: 'y',
      gap: 'X',
      flex: '1',

      MonthLabel: {
        text: '{{ month | polyglot }}',
        fontSize: 'Y',
        color: 'inkMuted',
        fontWeight: '600',
        textTransform: 'uppercase',
        letterSpacing: 'X'
      },

      MonthSelect: {
        tag: 'select',
        padding: 'Y Z',
        round: 'Y',
        border: '1px solid inkBorder',
        background: 'inkMid',
        color: 'inkText',
        fontSize: 'Z',
        width: '100%',
        cursor: 'pointer',
        value: (el, s) => s.historyFormMonth || '',
        onChange: (el, s) => {
          s.update({ historyFormMonth: el.node.value })
        },
        OptionDefault: { tag: 'option', value: '', text: '{{ selectMonth | polyglot }}' },
        OptionJan: { tag: 'option', value: '01', text: 'January' },
        OptionFeb: { tag: 'option', value: '02', text: 'February' },
        OptionMar: { tag: 'option', value: '03', text: 'March' },
        OptionApr: { tag: 'option', value: '04', text: 'April' },
        OptionMay: { tag: 'option', value: '05', text: 'May' },
        OptionJun: { tag: 'option', value: '06', text: 'June' },
        OptionJul: { tag: 'option', value: '07', text: 'July' },
        OptionAug: { tag: 'option', value: '08', text: 'August' },
        OptionSep: { tag: 'option', value: '09', text: 'September' },
        OptionOct: { tag: 'option', value: '10', text: 'October' },
        OptionNov: { tag: 'option', value: '11', text: 'November' },
        OptionDec: { tag: 'option', value: '12', text: 'December' }
      }
    },

    YearField: {
      flow: 'y',
      gap: 'X',
      flex: '1',

      YearLabel: {
        text: '{{ year | polyglot }}',
        fontSize: 'Y',
        color: 'inkMuted',
        fontWeight: '600',
        textTransform: 'uppercase',
        letterSpacing: 'X'
      },

      YearSelect: {
        tag: 'select',
        padding: 'Y Z',
        round: 'Y',
        border: '1px solid inkBorder',
        background: 'inkMid',
        color: 'inkText',
        fontSize: 'Z',
        width: '100%',
        cursor: 'pointer',
        value: (el, s) => s.historyFormYear || '',
        onChange: (el, s) => {
          s.update({ historyFormYear: el.node.value })
        },
        OptionDefault: { tag: 'option', value: '', text: '{{ selectYear | polyglot }}' },
        Option2026: { tag: 'option', value: '2026', text: '2026' },
        Option2025: { tag: 'option', value: '2025', text: '2025' },
        Option2024: { tag: 'option', value: '2024', text: '2024' },
        Option2023: { tag: 'option', value: '2023', text: '2023' },
        Option2022: { tag: 'option', value: '2022', text: '2022' },
        Option2021: { tag: 'option', value: '2021', text: '2021' },
        Option2020: { tag: 'option', value: '2020', text: '2020' }
      }
    }
  },

  DoctorField: {
    flow: 'y',
    gap: 'X',

    DoctorLabel: {
      text: '{{ doctorNameOptional | polyglot }}',
      fontSize: 'Y',
      color: 'inkMuted',
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: 'X'
    },

    DoctorInput: {
      tag: 'input',
      attr: { type: 'text', placeholder: '{{ enterDoctorName | polyglot }}' },
      padding: 'Y Z',
      round: 'Y',
      border: '1px solid inkBorder',
      background: 'inkMid',
      color: 'inkText',
      fontSize: 'Z',
      width: '100%',
      value: (el, s) => s.historyFormDoctor || '',
      onInput: (el, s) => {
        s.update({ historyFormDoctor: el.node.value })
      }
    }
  },

  ClinicField: {
    flow: 'y',
    gap: 'X',

    ClinicLabel: {
      text: '{{ clinicNameOptional | polyglot }}',
      fontSize: 'Y',
      color: 'inkMuted',
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: 'X'
    },

    ClinicInput: {
      tag: 'input',
      attr: { type: 'text', placeholder: '{{ enterClinicName | polyglot }}' },
      padding: 'Y Z',
      round: 'Y',
      border: '1px solid inkBorder',
      background: 'inkMid',
      color: 'inkText',
      fontSize: 'Z',
      width: '100%',
      value: (el, s) => s.historyFormClinic || '',
      onInput: (el, s) => {
        s.update({ historyFormClinic: el.node.value })
      }
    }
  },

  NotesField: {
    flow: 'y',
    gap: 'X',

    NotesLabel: {
      text: '{{ notes | polyglot }}',
      fontSize: 'Y',
      color: 'inkMuted',
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: 'X'
    },

    NotesTextarea: {
      tag: 'textarea',
      attr: { rows: '3', placeholder: '{{ enterNotes | polyglot }}' },
      padding: 'Y Z',
      round: 'Y',
      border: '1px solid inkBorder',
      background: 'inkMid',
      color: 'inkText',
      fontSize: 'Z',
      width: '100%',
      resize: 'vertical',
      value: (el, s) => s.historyFormNotes || '',
      onInput: (el, s) => {
        s.update({ historyFormNotes: el.node.value })
      }
    }
  },

  FormActions: {
    flow: 'x',
    gap: 'Z',
    align: 'center flex-end',
    marginTop: 'Y',

    CancelButton: {
      text: '{{ cancel | polyglot }}',
      padding: 'Z A',
      round: 'Y',
      background: 'inkMid',
      border: '1px solid inkBorder',
      color: 'inkText',
      cursor: 'pointer',
      fontWeight: '600',
      fontSize: 'Z',
      onClick: (el, s) => {
        s.root.update({ showHistoryForm: false })
      }
    },

    SubmitButton: {
      text: '{{ submitHistory | polyglot }}',
      padding: 'Z A',
      round: 'Y',
      background: 'teal',
      color: 'white',
      cursor: 'pointer',
      fontWeight: '600',
      fontSize: 'Z',
      onClick: (el, s) => {
        var tooth = Number(s.historyFormTooth)
        var procedure = s.historyFormProcedure
        if (!tooth || !procedure) return

        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        var monthIdx = Number(s.historyFormMonth || '1') - 1
        var year = s.historyFormYear || '2026'
        var dateStr = months[monthIdx] + ' ' + year

        var entry = {
          procedure: procedure,
          doctor: s.historyFormDoctor || '',
          clinic: s.historyFormClinic || '',
          date: dateStr,
          notes: s.historyFormNotes || '',
          verified: false
        }

        var toothHistory = Object.assign({}, s.root.toothHistory || {})
        var existing = toothHistory[tooth] ? toothHistory[tooth].slice() : []
        existing.unshift(entry)
        toothHistory[tooth] = existing

        s.root.update({ toothHistory: toothHistory, showHistoryForm: false })
        s.update({
          historyFormTooth: '',
          historyFormProcedure: '',
          historyFormMonth: '',
          historyFormYear: '',
          historyFormDoctor: '',
          historyFormClinic: '',
          historyFormNotes: ''
        })
      }
    }
  }
}
